/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Script from 'next/script';
import Style from './MeuFinanciamentoConsulte.css';
import CustomEmblaCarousel from '../CustomEmblaCarousel';
import Container from '@/components/atoms/Container';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function MeuFinanciamentoConsulte() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="c2c-conteudos">
        <ContainerHome24>
          <div className="is-mobi">
            <h2 className="c2c-conteudos-titulo">Consulte nossos conteúdos</h2>
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`c2c-conteudos-slide ${className}`}>
                    <a
                      href="blog/renegociar-ou-reorganizar.html"
                      target="_blank"
                      className="c2c-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-53/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-53/capa.png" />
                        <img
                          src="static/amp/blog/post-53/capa.png"
                          alt="Mulher lendo sobre como fazer um planejamento financeiro e decidindo entre renegociar ou reorganizar o financiamento."
                        />
                      </picture>
                      <div className="c2c-conteudos-card-textos">
                        <h3 className="c2c-conteudos-slide-titulo">
                          Precisa renegociar ou reorganizar o seu financiamento? Saiba o que fazer
                        </h3>
                        <p className="c2c-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`c2c-conteudos-slide ${className}`}>
                    <a
                      href="blog/quitar-ou-amortizar-financiamento-de-veiculos.html"
                      target="_blank"
                      className="c2c-conteudos-card"
                    >
                      <picture>
                        {/* <source type="image/webp" srcSet="static/amp/blog/post-49/capa.webp" /> */}
                        <source type="image/png" srcSet="static/amp/blog/post-49/capa.png" />
                        <img
                          src="static/amp/blog/post-49/capa.png"
                          alt="Mesa branca com um pote de vidro cheio de moedas com um papel por baixo e uma ponta de caneta e de calculadora, com um carro em miniatura vermelho por cima mostrando sobre o que fazer depois de quitar financiamento."
                        />
                      </picture>
                      <div className="c2c-conteudos-card-textos">
                        <h3 className="c2c-conteudos-slide-titulo">
                          Como quitar ou amortizar suas parcelas e economizar no financiamento de
                          veículos Santander!
                        </h3>
                        <p className="c2c-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`c2c-conteudos-slide ${className}`}>
                    <a
                      href="blog/vantagens-financiamento-de-veiculos.html"
                      target="_blank"
                      className="c2c-conteudos-card"
                    >
                      <picture>
                        {/* <source type="image/webp" srcSet="static/amp/blog/post-46/capa.webp" /> */}
                        <source type="image/jpg" srcSet="static/amp/blog/post-46/capa.jpg" />
                        <img
                          src="static/amp/blog/post-46/capa.jpg"
                          alt="mulher sentada em carro vermelho pensando sobre como funciona o financiamento de veículos"
                        />
                      </picture>
                      <div className="c2c-conteudos-card-textos">
                        <h3 className="c2c-conteudos-slide-titulo">
                          Financiamento de veículos: entenda as vantagens
                        </h3>
                        <p className="c2c-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            <h2 className="c2c-conteudos-titulo">Consulte nossos conteúdos</h2>
            <div className="cards-desk">
              <a
                href="blog/renegociar-ou-reorganizar.html"
                target="_blank"
                className="c2c-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-53/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-53/capa.png" />
                  <img
                    src="static/amp/blog/post-53/capa.png"
                    alt="Mulher lendo sobre como fazer um planejamento financeiro e decidindo entre renegociar ou reorganizar o financiamento."
                  />
                </picture>
                <div className="c2c-conteudos-card-textos">
                  <h3 className="c2c-conteudos-slide-titulo">
                    Precisa renegociar ou reorganizar o seu financiamento? Saiba o que fazer
                  </h3>
                  <p className="c2c-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/quitar-ou-amortizar-financiamento-de-veiculos.html"
                target="_blank"
                className="c2c-conteudos-card"
              >
                <picture>
                  {/* <source type="image/webp" srcSet="static/amp/blog/post-49/capa.webp" /> */}
                  <source type="image/png" srcSet="static/amp/blog/post-49/capa.png" />
                  <img
                    src="static/amp/blog/post-49/capa.png"
                    alt="Mesa branca com um pote de vidro cheio de moedas com um papel por baixo e uma ponta de caneta e de calculadora, com um carro em miniatura vermelho por cima mostrando sobre o que fazer depois de quitar financiamento."
                  />
                </picture>
                <div className="c2c-conteudos-card-textos">
                  <h3 className="c2c-conteudos-slide-titulo">
                    Como quitar ou amortizar suas parcelas e economizar no financiamento de veículos
                    Santander!
                  </h3>
                  <p className="c2c-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/vantagens-financiamento-de-veiculos.html"
                target="_blank"
                className="c2c-conteudos-card"
              >
                <picture>
                  {/* <source type="image/webp" srcSet="static/amp/blog/post-46/capa.webp" /> */}
                  <source type="image/jpg" srcSet="static/amp/blog/post-46/capa.jpg" />
                  <img
                    src="static/amp/blog/post-46/capa.jpg"
                    alt="mulher sentada em carro vermelho pensando sobre como funciona o financiamento de veículos"
                  />
                </picture>
                <div className="c2c-conteudos-card-textos">
                  <h3 className="c2c-conteudos-slide-titulo">
                    Financiamento de veículos: entenda as vantagens
                  </h3>
                  <p className="c2c-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default MeuFinanciamentoConsulte;
